/* eslint-disable */

import jsonp from "@/libs/api.request.js";
import {
  ref,
  onMounted,
  onBeforeMount,
  createApp,
  nextTick,
  watch,
  reactive,
} from "vue";
import Tabs from "@/class/Tabs";

interface ClassType {
  [key: string]: any;
  name?: string;
  transfer?: Class[];
  id: string;
}

interface Class {
  Title: string;
  HomeImagePath: string;
  OutLink: string;
  img: string
}

export default function useClasses() {
  let classes = reactive<{ data: ClassType[] }>({
    data: []
  });

  // watch(
  //   () => {
  //     return articleID.value;
  //   },
  //   (state, preState) => {
  //     if (!state) {
  //       show.value = false;
  //       return false;
  //     }
  //     show.value = true;
  //   }
  // );
  onBeforeMount(() => {
    getData()
  });
  function getData() {

    // 获取职业类型列表，内容约定在id 349575的文章中的 Summary字段里
    jsonp("https://news-my.web.sdo.com/UniInterface/news/newscontent.asp", {
      ApplicationCode: "20",
      Article: 349575,
      Type: "json",
    })
      .then(async (res: any) => {
        console.log(res.Content);
        for (const key in res.Content.split(",")) {


          let str = res.Content.split(",")[key]

          let id = str.split(";")[1]! as string;
          // console.log(id);
          let transfer = await getTransferList(id) as Class[]

          classes.data.push({
            name: str.split(";")[0] as string,
            transfer,
            id: id,
            img: str.split(";")[2]
          });
        }
        console.log(classes.data);

      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  function getTransferList(id: string) {

    return new Promise((resolve, rej) => {
      jsonp("https://news-my.web.sdo.com/UniInterface/news/newslist.asp", {
        CategoryCode: id,
        Type: "json",
        pageSize: 100,
        pageIndex: 0,
      })
        .then((res: any) => {
          let data = res.dataList.slice(1, res.dataList.length)
            .map((i: string[]) => {
              return {
                // ID: i[0],
                // Articletype: i[1],
                // ApplicationCode: i[2],
                // CategoryCode: i[3],
                // SortIndex: i[4],
                // GroupIndex: i[5],
                Title: i[6],
                // TitleClass: i[7],
                // Summary: i[8].split(";")[1],
                // Author: i[9],
                // Keyword: i[10],
                HomeImagePath: i[11],
                // PublishDate: i[12],
                OutLink: i[13],
                // AccessoryLink: i[14],
                // AccessoryTitle: i[15],
              };
            });
          resolve(data)

        })
        .catch((err: any) => {
          console.log(err);
        });
    })

  }

  return { classes };
}
